<ng-container *ngIf="transformedRowData?.length || isLoading">
  <div class="filter-container">
    <app-grid-quick-filter [configStoreTableName]="configStoreTableName">
    </app-grid-quick-filter>
  </div>

  <app-ag-grid-options
    [showQuickFilter]="false"
    [configStoreTableName]="configStoreTableName"
  >
  </app-ag-grid-options>

  <div class="table-container">
    <mat-progress-spinner
      *ngIf="isLoading"
      class="table-spinner"
      diameter="50"
      mode="indeterminate"
    >
    </mat-progress-spinner>

    <ag-grid-angular
      columnHoverHighlight
      rowHoverHighlight
      class="ag-theme-adap ag-sticky"
      [rowData]="transformedRowData"
      [columnDefs]="columnDefs"
      [components]="components"
      domLayout="normal"
      rowClass="ag-no-border"
      configStore
      [configStoreTableName]="configStoreTableName"
      columnSizeStrategy="sizeColumnsToFit"
      suppressScrollOnNewData
    >
    </ag-grid-angular>
  </div>
</ng-container>
